import styled from '@emotion/styled'
import { Colors } from 'src/components/theme'

type SquareIconProps = {
  color: string
  size: number
  padding?: number
}

export const SquareIcon = styled.span<SquareIconProps>`
  flex: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props) => props.size}px;
  min-height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  min-width: ${(props) => props.size}px;
  border-radius: 6px;
  background-color: ${(props) => props.color};
  padding: ${(props) => props.padding || 0}px;
  svg {
    color: ${Colors.bgWhite};
  }
`
